import type { ColGroupDef } from 'ag-grid-community'

import AnalyticsKpisBuilder from '../AnalyticsKpisBuilder'
import { formatMoney } from '../utils'

export const uaEroiEuroDefs: ColGroupDef = {
  children: [
    {
      aggFunc: 'sum',
      field: 'ua_eroi_eur_d30',
      headerName: 'D30',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'sum',
      field: 'ua_eroi_eur_d10',
      headerName: 'D10',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'sum',
      field: 'ua_eroi_eur_d7',
      headerName: 'D7',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'sum',
      field: 'ua_eroi_eur_d3',
      headerName: 'D3',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'sum',
      field: 'ua_eroi_eur_d0',
      headerName: 'D0',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
  ],
  headerClass: 'greyFill',
  headerName: 'UA eROI €',
}
